module.exports = __webpack_public_path__ + "img/presta-shop.bf5b0a88.svg";